import axios from 'axios';
import z from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import { createValidator } from 'functions/validation/zod';

// No PathParameters

export const QueryParametersSchema = z.object({
	fileIds: z.string().array(),
	fileType: z.string(),
});

const ResponseDataSchema = z.any();
export type ResponseData = z.infer<typeof ResponseDataSchema>;
const validator = createValidator(ResponseDataSchema);

export type RequestBody = z.infer<typeof QueryParametersSchema>;

export async function callApi(input: { requestBody: RequestBody }): Promise<Blob> {
	const url = SERVICEBASEURL.REPORT + `/v1/files/download`;

	// Determine Accept header based on fileType
	const fileType = input.requestBody.fileType;
	const acceptHeader = fileType === 'source' ? 'text/csv,application/octet-stream' : 'application/zip';

	// ✅ Direct axios call, skip `.toOptionalFiltered`
	const response = await axios.post(url, input.requestBody, {
		responseType: 'blob',
		headers: {
			'Content-Type': 'application/json',
			Accept: acceptHeader,
		},
	});

	return response.data; // Blob
}
